export const degreePointsMap: Record<number, number> = {
  1: 0,
  2: 2,
  3: 8,
  4: 14,
  5: 17,
  6: 18,
};

export const degreeExemptMathAndPolishMapping: Record<number, number> = {
  1: 0,
  2: 10,
  3: 15,
  4: 25,
  5: 30,
  6: 35,
};

export const degreeExemptOtherSubjectMapping: Record<number, number> = {
  1: 0,
  2: 5,
  3: 10,
  4: 20,
  5: 25,
  6: 30,
};
